import { Serializable } from '../../../core/models/serializable';
import { ProductType } from '../../../product-purchases/shared/models/product-type';
import { AnnouncementModel } from '@admin/announcements/shared/models/announcement-model';
import { UserModel } from '@admin/core/user-model.model';
import { JobseekerModel } from '@admin/jobseekers/shared/models/jobseeker-model';
import { AnnouncementDistributionChannel } from '@admin/announcements/shared/models/announcement-distribution-channel';
import { JobseekerMatchedAnnouncement } from './jobseeker-matched-announcement';

export class AnnouncementMatchingListModel
  implements Serializable<AnnouncementMatchingListModel>
{
  announcementMatchingListId: number;
  announcement: AnnouncementModel;
  createDate: Date;
  createUser: UserModel;
  isAutoGenerated: boolean;
  isRegenerated: boolean;
  lastUpdateDate: Date;
  lastUpdateUser: UserModel;
  approvalStatus: number;
  approveDate: Date;
  approveUser: UserModel;
  plannedSendDate: Date;
  isEmailGenerated: boolean;
  emailMessageId: number;
  generationStatus: number;
  matchingJobseekers: AnnouncementMatchingJobseekerModel[];

  fromObject(object: any): AnnouncementMatchingListModel {
    Object.assign(this, object);

    this.matchingJobseekers = [];

    if (
      object.matchingJobseekers &&
      object.matchingJobseekers.length &&
      object.matchingJobseekers.length > 0
    ) {
      object.matchingJobseekers.forEach((d) => {
        let t = new AnnouncementMatchingJobseekerModel();
        t = t.fromObject(d);
        this.matchingJobseekers.push(t);
      });
    }

    if (object.announcement != null) {
      let t = new AnnouncementModel();
      t = t.fromObject(object.announcement);
      this.announcement = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  constructor() {
    this.matchingJobseekers = [];
  }
}

export class AnnouncementMatchingJobseekerModel
  implements Serializable<AnnouncementMatchingJobseekerModel>
{
  announcementMatchingJobseekerId: number;
  announcementMatchingListId: number;
  announcementId: number;
  // public long JobseekerId { get; set; }
  jobseeker: JobseekerModel;
  currentPositionFinalScore: number;
  bestPositionFinalScore: number;
  bestPositionAgePenalty: number;
  bestPositionKeywordScore: number;
  currentCategoryFinalScore: number;
  currentSubCategoryScore: number;
  currentHeadCategoryScore: number;
  bestCategoryFinalScore: number;
  bestSubCategoryScore: number;
  bestHeadCategoryScore: number;
  currentAggregatedCategoryFinalScore: number;
  currentAggregatedSubCategoryScore: number;
  currentAggregatedHeadCategoryScore: number;
  bestAggregatedCategoryFinalScore: number;
  bestAggregatedSubCategoryScore: number;
  bestAggregatedHeadCategoryScore: number;
  mandatoryLanguageScore: number;
  optionalLanguageScore: number;
  languageFinalScore: number;
  drivingLicenseFinalScore: number;
  locationFinalScore: number;
  experienceFinalScore: number;
  experienceSubCategoryScore: number;
  experienceHeadCategoryScore: number;
  finalScore: number;
  // public int StatusId { get; set; }
  status: number;
  distributionChannels: AnnouncementDistributionChannel[];
  lastStatusUpdateDate: Date;
  lastStatusUpdateUser: UserModel;

  jobseekerMatchedAnnouncements: JobseekerMatchedAnnouncement[];
  isHighlight: boolean;
  isMatchingProductBought: boolean;

  fromObject(object: any): AnnouncementMatchingJobseekerModel {
    Object.assign(this, object);

    this.jobseekerMatchedAnnouncements = [];

    if (
      object.jobseekerMatchedAnnouncements &&
      object.jobseekerMatchedAnnouncements.length &&
      object.jobseekerMatchedAnnouncements.length > 0
    ) {
      object.jobseekerMatchedAnnouncements.forEach((d) => {
        let t = new JobseekerMatchedAnnouncement();
        t = t.fromObject(d);
        this.jobseekerMatchedAnnouncements.push(t);
      });
    }

    this.distributionChannels = [];

    if (
      object.distributionChannels &&
      object.distributionChannels.length &&
      object.distributionChannels.length > 0
    ) {
      object.distributionChannels.forEach((d) => {
        let t = new AnnouncementDistributionChannel();
        t = t.fromObject(d);
        this.distributionChannels.push(t);
      });
    }

    return this;
  }

  toObject() {
    return {
      announcementMatchingJobseekerId: this.announcementMatchingJobseekerId,
      announcementMatchingListId: this.announcementMatchingListId,
      announcementId: this.announcementId,
      jobseeker: JobseekerModel,
      currentPositionFinalScore: this.currentPositionFinalScore,
      bestPositionFinalScore: this.bestPositionFinalScore,
      bestPositionAgePenalty: this.bestPositionAgePenalty,
      bestPositionKeywordScore: this.bestPositionKeywordScore,
      currentCategoryFinalScore: this.currentCategoryFinalScore,
      currentSubCategoryScore: this.currentSubCategoryScore,
      currentHeadCategoryScore: this.currentHeadCategoryScore,
      bestCategoryFinalScore: this.bestCategoryFinalScore,
      bestSubCategoryScore: this.bestSubCategoryScore,
      bestHeadCategoryScore: this.bestHeadCategoryScore,
      currentAggregatedCategoryFinalScore:
        this.currentAggregatedCategoryFinalScore,
      currentAggregatedSubCategoryScore: this.currentAggregatedSubCategoryScore,
      currentAggregatedHeadCategoryScore:
        this.currentAggregatedHeadCategoryScore,
      bestAggregatedCategoryFinalScore: this.bestAggregatedCategoryFinalScore,
      bestAggregatedSubCategoryScore: this.bestAggregatedSubCategoryScore,
      bestAggregatedHeadCategoryScore: this.bestAggregatedHeadCategoryScore,
      languageFinalScore: this.languageFinalScore,
      drivingLicenseFinalScore: this.drivingLicenseFinalScore,
      locationFinalScore: this.locationFinalScore,
      experienceFinalScore: this.experienceFinalScore,
      experienceSubCategoryScore: this.experienceSubCategoryScore,
      experienceHeadCategoryScore: this.experienceHeadCategoryScore,
      finalScore: this.finalScore,
      status: this.status,
      distributionChannels: this.distributionChannels,
      lastStatusUpdateDate: this.lastStatusUpdateDate,
      lastStatusUpdateUser: this.lastStatusUpdateUser,
      jobseekerMatchedAnnouncements: this.jobseekerMatchedAnnouncements,
      isHighlight: this.isHighlight,
    };
  }

  public get fullName() {
    return `${this.jobseeker.surname} ${this.jobseeker.name}`;
  }

  constructor() {
    this.distributionChannels = [];
    this.jobseekerMatchedAnnouncements = [];
  }
}
